<section class="not-allowed">
  <h1 class="txt txt-web-h2 u-mb20">No cuentas con acceso</h1>
  <h3 class="txt txt--grey txt-web-body-large u-mb50">
    Esta página requiere de una autorización especial.
    Favor de contactarse con el administrador.
  </h3>
  <img src="../../../../assets/images/admin-login.svg" alt="Error" />
  <button class="vs-btn-blue" (click)="goBack()">
    Regresar
  </button>
</section>